import styled, { css } from "styled-components";

import { Default } from "Types";

import AtomDot from "Components/Atoms/Dot";
import MoleculeStepButton from "Components/Molecules/StepButton";
import { typography } from "globalConstants";

export type PropsType = any;

const Wrap = styled.div<Default>`
   display: flex;
   ${({ css }) => css}
`;

const DotsWrap = styled.div`
   display: flex;
   flex-direction: row;
   column-gap: 17px;
   padding: 12.5px 14px;
`;

const cssActiveBlack = css`
   background-color: black;
`;
const cssActivePurple = css`
   background-color: ${typography.other.color.purple[0]};
`;
const cssActiveTextBlack = css`
   color: black;
`;
const cssActiveTextPurple = css`
   color: ${typography.other.color.purple[0]};
`;

export default function Dot(props: PropsType) {
   const { step } = props;
   return (
      <Wrap {...props}>
         <MoleculeStepButton cssText={cssActiveTextBlack} cssNumber={cssActiveBlack} number={1} text={"신청인 정보"}></MoleculeStepButton>
         <DotsWrap>
            <AtomDot css={step >= 2 ? cssActiveBlack : css``}></AtomDot>
            <AtomDot css={step >= 2 ? cssActiveBlack : css``}></AtomDot>
            <AtomDot css={step >= 2 ? cssActiveBlack : css``}></AtomDot>
         </DotsWrap>
         <MoleculeStepButton cssText={step >= 2 && cssActiveTextBlack} cssNumber={step >= 2 && cssActiveBlack} number={2} text={"전시 등록"}></MoleculeStepButton>
         <DotsWrap>
            <AtomDot css={step >= 3 ? cssActiveBlack : css``}></AtomDot>
            <AtomDot css={step >= 3 ? cssActiveBlack : css``}></AtomDot>
            <AtomDot css={step >= 3 ? cssActiveBlack : css``}></AtomDot>
         </DotsWrap>
         <MoleculeStepButton cssText={step >= 3 && cssActiveTextBlack} cssNumber={step >= 3 && cssActiveBlack} number={3} text={"첨부파일 업로드"}></MoleculeStepButton>
         <DotsWrap>
            <AtomDot css={step >= 4 ? cssActiveBlack : css``}></AtomDot>
            <AtomDot css={step >= 4 ? cssActiveBlack : css``}></AtomDot>
            <AtomDot css={step >= 4 ? cssActiveBlack : css``}></AtomDot>
         </DotsWrap>
         <MoleculeStepButton cssText={step >= 4 && cssActiveTextBlack} cssNumber={step >= 4 && cssActiveBlack} number={4} text={"확인"}></MoleculeStepButton>
         <DotsWrap>
            <AtomDot css={step >= 5 ? cssActiveBlack : css``}></AtomDot>
            <AtomDot css={step >= 5 ? cssActiveBlack : css``}></AtomDot>
            <AtomDot css={step >= 5 ? cssActiveBlack : css``}></AtomDot>
         </DotsWrap>
         <MoleculeStepButton cssText={step >= 5 && cssActiveTextPurple} cssNumber={step >= 5 && cssActivePurple} number={5} text={"결제 완료"}></MoleculeStepButton>
      </Wrap>
   );
}
